import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import ProductVisual from "./ProductVisual";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your selection is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <h1 className="cart-title">Selection</h1>
        <div className="empty-cart">
          <p>Your selection is empty</p>
          <Link onClick={toTop} to="/shop" className="continue-shopping-link">
            Browse the catalogue
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <h1 className="cart-title">Selection</h1>
      <div className="cart-items">
        {cartItems.map((item, index) => {
          const product = getProductById(item.id);
          if (!product) return null;
          return (
            <div key={index} className="cart-item">
              <div className="item-image-wrapper">
                <Link to={`/shopDetails/${item.id}`} onClick={toTop}>
                  <ProductVisual product={product} compact />
                </Link>
              </div>
              <div className="item-details">
                <Link
                  to={`/shopDetails/${item.id}`}
                  onClick={toTop}
                  className="item-name-link"
                >
                  <h3 className="item-name">{product.name}</h3>
                </Link>
                <div className="item-price">${product.price}</div>
                <div className="item-size">SIZE: {item.size || "ONE SIZE"}</div>
                <div className="quantity-controls">
                  <div className="quantity-wrapper">
                    <span className="quantity-label">QUANTITY</span>
                    <button
                      className="quantity-btn"
                      onClick={() =>
                        handleUpdateQuantity(
                          item.id,
                          item.size,
                          item.color,
                          item.quantity - 1
                        )
                      }
                    >
                      −
                    </button>
                    <span className="quantity-value">{item.quantity}</span>
                    <button
                      className="quantity-btn"
                      onClick={() =>
                        handleUpdateQuantity(
                          item.id,
                          item.size,
                          item.color,
                          item.quantity + 1
                        )
                      }
                    >
                      +
                    </button>
                  </div>
                  <div className="item-actions">
                    <button
                      className="action-link remove-link"
                      onClick={() =>
                        removeFromCart(item.id, item.size, item.color)
                      }
                    >
                      REMOVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="cart-summary">
        <p className="cart-preview-note">This is a preview selection. No order or payment will be created.</p>
        <div className="summary-row">
          <span className="summary-label">Total:</span>
          <span className="summary-value">${subtotal.toFixed(2)}</span>
        </div>
        <div className="delivery-note">Availability must be confirmed before purchase.</div>
        <button className="checkout-btn" onClick={handleCheckout}>
          REVIEW SELECTION
        </button>
      </div>
    </div>
  );
};

export default CartPage;
